import { useCallback } from 'react';

const useValidation = ({
  generateNameAutomatically,
  selectedIOSPlatform,
  selectedAndroidPlatform,
  selectedPlariumPlayPlatform,
  selectedPortalPlatform,
}) => {
  const validationName = useCallback(
    value => {
      if (!generateNameAutomatically && !value) {
        return 'Name is required';
      }
    },
    [generateNameAutomatically]
  );

  const validationPayoutAndroid = useCallback(
    value => {
      if (selectedAndroidPlatform && !value) {
        return 'Android is required';
      }
    },
    [selectedAndroidPlatform]
  );

  const validationPayoutIOS = useCallback(
    value => {
      if (selectedIOSPlatform && !value) {
        return 'iOS is required';
      }
    },
    [selectedIOSPlatform]
  );

  const validationPayoutPlariumPlay = useCallback(
    value => {
      if (selectedPlariumPlayPlatform && !value) {
        return 'Plarium Play is required';
      }
    },
    [selectedPlariumPlayPlatform]
  );

  const validationPayoutPortal = useCallback(
    value => {
      if (selectedPortalPlatform && !value) {
        return 'Portal is required';
      }
    },
    [selectedPortalPlatform]
  );

  const validationLandingPage = useCallback(
    value => {
      if (selectedPlariumPlayPlatform && !value) {
        return 'Conversion page is required';
      }
    },
    [selectedPlariumPlayPlatform]
  );

  return {
    validationName,
    validationPayoutAndroid,
    validationPayoutIOS,
    validationPayoutPlariumPlay,
    validationPayoutPortal,
    validationLandingPage,
  };
};

export default useValidation;
